// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"SwitchLanguage_dropdownMenu__3Sq4m","dropdownToggle":"SwitchLanguage_dropdownToggle__b-NG9"};